<template>
  <div class="total-container">
    <div class="box-wrapper total-valume">
      <p class="label">TOTAL VOLUME</p>
      <p class="valume">${{ totalValume | numberWithComma(0) }} </p>
    </div>
    <div class="box-wrapper top-trade">
      <p class="label">TOP TOKEN BY VOLUME</p>
      <div class="token-wrapper">
        <div class="token-name-img">
          <img
            v-if="topTokenTrade.labelCode !== '-'"
            :src="`/static/token/normal/${topTokenTrade.labelCode.toLowerCase()}.svg`">
        </div>
        <div class="token-name-lable">
          <div class="token-name-lable-code">
            {{ topTokenTrade.labelCode }}
          </div>
          <div class="token-name-lable-fullname">
            {{ topTokenTrade.fullName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalTopTrade',
  props: {
    totalValume: {
      type: Number,
      default: 0
    },
    topTokenTrade: {
      type: Object,
      default () {
        return {
          labelCode: '-', // mock data
          fullName: '-'
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
.total-container {
  display: flex;
  justify-content:center;
  flex-wrap: wrap;
  margin: 40px 0;
}
.box-wrapper {
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  margin: 0 14px;
  .label {
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 23px;
    letter-spacing: 0em;
  }
  &.total-valume {
    text-align: center;
    .valume {
      font-family: DINAlternate !important;
      font-size: 40px;
      font-style: normal;
      font-weight: 700;
      line-height: 52px;
      letter-spacing: 0em;
      line-height: normal;
    }
  }

  &.top-trade {
    .token-wrapper {
      margin-top: 5px;
      display: flex;
    }
    .token-name-col {
      width: 100%;
      height: 90px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding: 10px;
      padding-left: 50px;
    }
    .token-name-img {
      height: 40px;
      width: 40px;
      padding: 5px;
    }
    .token-name-lable {
      float: left;
      margin-left: 10px;
      width: calc(100% - 40px);
    }
    .token-name-lable-code {
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.5px;
      color: #363636;
    }
    .token-name-lable-fullname {
      font-size: 14px;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: 0.3px;
      color: #363636;
    }
  }
}
@media screen and (max-width: 1024px){
  .box-wrapper {
    margin: 14px 14px;
  }
}

@media screen and (max-width: 768px){
  .total-container {
    margin: 30px 0 29px;
  }
  .box-wrapper {
    min-width: 250px;
    .label {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/features/TopTrader/components/TotalTopTrade.vue